import clsx from 'clsx';
import { ReactNode } from 'react';

interface Props {
  title: string;
  children: ReactNode;
  isEditing?: boolean;
  headerAction?: ReactNode;
  headerInfo?: ReactNode;
  compact?: boolean;
}

export function SOPCard(props: Props) {
  const {
    title,
    children,
    isEditing = false,
    headerAction,
    headerInfo,
    compact = false,
  } = props;

  return (
    <div
      className={clsx(
        'bg-onlight-bg-1 dark:bg-ondark-bg-1 border-onlight-line-1 dark:border-ondark-line-1 rounded-lg border p-4',
        compact &&
          '!border-0 !p-2 [&>:first-child]:!mb-1 [&_[class*=space-y-]>*+*]:!mt-2'
      )}
    >
      <div className="mb-4 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <h3 className="text-md font-semibold">{title}</h3>
          {headerInfo}
        </div>
        {headerAction}
      </div>
      <div className={isEditing ? 'space-y-4' : ''}>{children}</div>
    </div>
  );
}

export default SOPCard;
